module.exports = __webpack_public_path__ + "img/stripe.fba77076.png";